import { Product } from "@~/types/types";

export type CardEventDetail = {
  pimProductId: string;
  variantId: string;
  skuId: string;
  instanceId: string | undefined;
  consumerId: string;
  index: number;
  quantity: number | undefined;
  product: {
    currency: string;
    hasSpecialOffer: boolean;
    noOfReviews: number;
    rating: string;
    priceHistory?: {
      chronology: number;
      display: {
        max: string;
        min: string;
      };
    }[];
    advertising?: {
      associatedAdvertId: string;
      clickUrl?: string;
      impressionUrl?: string;
    };
  };
};

export type CardEventContext = {
  product: Product;
  index: number;
  quantity?: number;
  instanceId?: string;
  consumerId: string;
  variantId?: string;
  skuId?: string;
};

export function buildCardEventDetail(
  context: CardEventContext,
): CardEventDetail {
  const { product, index, quantity, instanceId, consumerId, variantId, skuId } =
    context;
  return {
    pimProductId: product.aliases.pimProductId,
    variantId: variantId || "",
    skuId: skuId || "",
    instanceId: instanceId,
    consumerId: consumerId,
    index: index,
    quantity: quantity,
    product: {
      currency: "GBP",
      hasSpecialOffer: hasSpecialOffer(product),
      noOfReviews: product.reviewSummary?.numberOfReviews || 0,
      rating: String(product.reviewSummary?.averageRating || ""),
      priceHistory: product.variantPriceRange?.reductionHistory,
      advertising: product.advertising,
    },
  };
}

function hasSpecialOffer(product: Product): boolean {
  const { messaging } = product;
  return messaging
    ? messaging?.filter((m) => m.type === "promotional").length > 0
    : false;
}
